function t(e) {
  let r = e;
  return typeof e == "number" ? r = e : typeof e == "string" && (e.includes("px") && (r = parseInt(e.replace("px", ""))), r = parseInt(e)), Number.isNaN(r) ? 0 : r;
}
export {
  t as getAsNumber
};
//# sourceMappingURL=getAsNumber.es.js.map
